import { lazy } from 'react';
import { UserTypes } from '@/configs/AppConfig';
import { MOD_APP_USER } from '@/configs/ModulesConfig';
import { Navigate } from "react-router-dom";

const AppUserList = lazy(() => import('./AppUserList'));


const route = [
    {
        path: MOD_APP_USER.base_path,
        element: <Navigate to={MOD_APP_USER.routes.list} replace />,
        auth: MOD_APP_USER.auth
    },
    {
        path: MOD_APP_USER.routes.list,
        element: <AppUserList />,
        auth: MOD_APP_USER.auth
    },
];



export default route;